import { render, staticRenderFns } from "./AbaContato.vue?vue&type=template&id=5891e1da"
import script from "./AbaContato.vue?vue&type=script&lang=js"
export * from "./AbaContato.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports